/* Animación de clic para botones y tarjetas.
   Solo se dispara en un clic normal: si se mantiene presionado
   más de MAX_MS, no se anima. */
(function () {
  var SELECTOR = [
    '#MainContent .button',
    '#MainContent .button-secondary',
    '.mild-drawer__cta',
    '#header-component .header__icon',
    '.mild-links__item'
  ].join(',');

  var MAX_MS = 400;   // más tiempo presionado = pulsación larga, no se anima
  var MAX_MOVE = 10;  // si el dedo/ratón se mueve, es arrastre o scroll
  var start = 0, sx = 0, sy = 0, target = null;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0 && e.pointerType === 'mouse') return; // solo botón principal
    var el = e.target.closest && e.target.closest(SELECTOR);
    if (!el) { target = null; return; }
    target = el; start = Date.now(); sx = e.clientX; sy = e.clientY;
  }, true);

  document.addEventListener('pointerup', function (e) {
    if (!target) return;
    var el = target; target = null;
    if (Date.now() - start > MAX_MS) return;                       // pulsación larga
    if (Math.abs(e.clientX - sx) > MAX_MOVE) return;               // arrastre
    if (Math.abs(e.clientY - sy) > MAX_MOVE) return;
    el.classList.remove('mild-clicked');
    void el.offsetWidth;                                           // reinicia la animación
    el.classList.add('mild-clicked');
    el.addEventListener('animationend', function handler() {
      el.classList.remove('mild-clicked');
      el.removeEventListener('animationend', handler);
    });
  }, true);

  document.addEventListener('pointercancel', function () { target = null; }, true);
})();
